import URL from 'url-parse';

export const getExternalPartnerLoginPath = (href: string, isPsn?: boolean) => {
  if (isPsn) {
    return 'https://areaprivata-pokerstars.sisal.it/loginJwt';
  }

  return (
    new URL('', {})
      .set('pathname', 'auth/psn-authorization-callback')
      // eslint-disable-next-line @typescript-eslint/naming-convention
      .set('query', { redirect_uri: href })
      .toString()
  );
};
